import { render } from "./KappNews.vue?vue&type=template&id=ef91fa28&scoped=true"
import script from "./KappNews.vue?vue&type=script&lang=js"
export * from "./KappNews.vue?vue&type=script&lang=js"

import "./KappNews.vue?vue&type=style&index=0&id=ef91fa28&scoped=true&lang=scss"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef91fa28"]])

export default __exports__